/**
 * Generator function that yields chunks of an array one at a time
 * @param {Array} array - The array to be chunked
 * @param {number} size - The size of each chunk
 * @yields {Array} - A chunk of the specified size
 * @example
 * for (const chunk of chunks([1, 2, 3, 4, 5], 2)) {
 *   console.log(chunk); // [1, 2] then [3, 4] then [5]
 * }
 */
function* chunks(array, size) {
  if (!Array.isArray(array) || size < 1) {
    return;
  }

  for (let i = 0; i < array.length; i += size) {
    yield array.slice(i, i + size);
  }
}

export default chunks;
